import { useCallback, useEffect, useState } from 'react';

import {
  addNewProjectProductFromSearch,
  findAvailableProjects
} from '../../../../api/services/ProjectsService';
import { FetchResponse, Option } from '../../../../types/global';
import { Project } from '../../../../types/Projects';
import './AddToProjectModal.scss';
import { EventSearchDocument } from 'types/Search';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField
} from '@mui/material';
import { CompanySelectorMui } from 'components/common/CompanySelectorMui';
import { useUserState } from 'context/User';
import { isSupport } from 'helpers/Roles';
import { UserStateContextType } from 'components/constants/Constants';
interface AddToProjectModalProps {
  product: EventSearchDocument;
  show: boolean;
  setShow: Function;
  [x: string]: any;
}

const AddToProjectModal = ({
  product,
  setShow,
  show,
  ...props
}: AddToProjectModalProps) => {
  const [company, setCompany] = useState<Option | null>(null);
  const [projects, setProjects] = useState<any[] | undefined>();
  const [project, setProject] = useState('');
  const user = useUserState();
  const userCompany =
    user.type === UserStateContextType.AUTHENTICATED
      ? user?.user?.assignedCompanies?.[0]?.key
      : undefined;
  const selectedCompany = company?.value ?? userCompany;
  const isSupportUser =
    user.type === UserStateContextType.AUTHENTICATED && isSupport(user.user);
  const loadAvailableProjects = useCallback(() => {
    findAvailableProjects(selectedCompany, product, (res: FetchResponse) =>
      setProjects(res.data.content)
    );
  }, [product, selectedCompany]);
  useEffect(() => {
    selectedCompany && loadAvailableProjects();
  }, [loadAvailableProjects, selectedCompany]);

  const handleSave = () => {
    addNewProjectProductFromSearch(selectedCompany, project, product, () => {
      setShow(false);
    });
  };
  return (
    <Dialog open={show} maxWidth="md" fullWidth onClose={() => setShow(false)}>
      <DialogTitle>{`Add ${product.name} to your project`}</DialogTitle>
      <DialogContent>
        {isSupportUser && (
          <CompanySelectorMui
            value={company ?? null}
            onSelect={(company: Option) => setCompany(company)}
          />
        )}

        {projects && (
          <TextField
            sx={{ mt: 2 }}
            select
            fullWidth
            placeholder="Select a project"
            label="Project"
            value={project}
            onChange={e => setProject(e.target.value)}
          >
            {projects.map((proj: Project) => (
              <MenuItem key={proj.key} value={proj.key}>
                {proj.title}
              </MenuItem>
            ))}
            {projects.length === 0 && (
              <MenuItem disabled>No projects available</MenuItem>
            )}
          </TextField>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShow(false)}>Close</Button>
        <Button variant="contained" disabled={!project} onClick={handleSave}>
          Add to project
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddToProjectModal;
